import { sendingOnExit } from "./client";

/** Écritures différées de quelques centaines de millisecondes (curseur de potentiel, ⌘Z de la carte) : envoyées
 *  aussitôt quand la page passe en arrière-plan ou se ferme, en requêtes non interruptibles (audit de persistance
 *  m11). Chaque écriture différée s'inscrit ici tant qu'elle existe. */

const flushers = new Set<() => void>();
let installed = false;

function flushAll(): void {
  sendingOnExit(() => {
    for (const flush of flushers) {
      try {
        flush();
      } catch {
        /* une écriture impossible n'empêche pas les autres */
      }
    }
  });
}

/** Inscrit une écriture différée à envoyer à la fermeture ; rend le désabonnement. */
export function onExit(flush: () => void): () => void {
  flushers.add(flush);
  if (!installed && typeof window !== "undefined") {
    installed = true;
    window.addEventListener("pagehide", flushAll);
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "hidden") flushAll();
    });
  }
  return () => {
    flushers.delete(flush);
  };
}
